import { render } from "./PreviewMaterialSymbol.vue?vue&type=template&id=0b3c269a&scoped=true&ts=true"
import script from "./PreviewMaterialSymbol.vue?vue&type=script&lang=ts"
export * from "./PreviewMaterialSymbol.vue?vue&type=script&lang=ts"

import "./PreviewMaterialSymbol.vue?vue&type=style&index=0&id=0b3c269a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3c269a"]])

export default __exports__